export default __webpack_public_path__ + "static/media/calendar-header.9db857ef.svg";